<template>
    <div class="lgsorder-details">
        <ul class="brt">
            <li v-for="(apptipsItem, apptipsIndex) in lgspaymentDetails.apptips" :key="apptipsIndex">
                <span>{{ apptipsItem.key }}</span>
                <span>{{ apptipsItem.value }}</span>
            </li>
            <!--  <li>
                <span>认购金额</span>
                <span>100,000元</span>
            </li>
            <li>
                <span>期限</span>
                <span>8.90%</span>
            </li>
            <li>
                <span>预期年化收益率</span>
                <span>8.90%</span>
            </li>
            <li>
                <span>起息日</span>
                <span>到账后次工作日</span>
            </li>
            <li>
                <span>交易状态</span>
                <span>已付款</span>
            </li>
            <li>
                <span>交易单号</span>
                <span>20170417133299324</span>
            </li>
            <li>
                <span>签约时间</span>
                <span>2017-10-09 12:50</span>
            </li>

            <li>
                <span>银行账户</span>
                <span>招商银行（尾号6554）</span>
            </li>
            <li>
                <span>收款银行</span>
                <span>中国工商银行</span>
            </li>
            <li>
                <span>账户名称</span>
                <span>哈尔滨金融产权交易中心有限责任公司</span>
            </li>
            <li>
                <span>账户账号</span>
                <span>8940823948923</span>
            </li> -->
        </ul>
        <ul class="sy" v-if="lgspaymentDetails.investApplyno">
            <li @click="toSydetailsRefund(lgspaymentDetails.investApplyno)">
                <span>收益分配</span>
                <span class="arrow"></span>
            </li>
        </ul>
        <ul class="brb">
            <li v-if="lgspaymentDetails.files && lgspaymentDetails.files.length > 0" @click="relatedFile">
                <span>相关文件</span>
                <span class="arrow"></span>
            </li>
            <li @click="downFile($event)" :data-dealNo="lgspaymentDetails.appRequestId">
                <span>相关协议</span>
                <span class="arrow"></span>
            </li>
        </ul>
        <p class="order-adviser mt8">获取纸质合同，请联系您的咨询顾问</p>
        <div v-if="filesBoxFlag" class="files-box">
            <div class="mask" @click="filesBoxFlag = false"></div>
            <div class="files-list">
                <ol>
                    <li v-for="(item, index) in lgspaymentDetails.files" :key="index" @click="relatedFile(item.materialId)">{{ item.materialName }}</li>
                    <li class="cancel" @click="filesBoxFlag = false">取消</li>
                </ol>
            </div>
        </div>
        <div class="view-protocol" v-if="lgspaymentDetails.investApplyno && lgspaymentDetails.tradeStatus === '10'">
            <div class="smallBtn" @click="cancelOrder">取消订单</div>
        </div>
    </div>
</template>
<script>
    import {bridgeRedirect, callHandler, downloadFile} from "../../../utils/bridge";
    import { formatNumber } from "@/utils/index";
    import sensors from "sa-sdk-javascript";

    export default {
        data() {
            return {
                lgspaymentDetails: {},
                token: "",
                tradeId: "",
                filesBoxFlag: false
            };
        },
        created() {
            const urlParams = this.$route.query;
            const { token, tradeId } = urlParams;
            this.token = decodeURIComponent(token || "");
            this.tradeId = tradeId;
            //decodeURIComponent(tradeId || "");
            this.getData(this.token, this.tradeId);
        },

        methods: {
            getData: function(token, tradeId) {
                this.$request({
                    method: "post",
                    url: "/h5/sesame/tradeDetail.json",
                    data: this.$qs.stringify({
                        tradeId: tradeId,
                        token: token
                    })
                })
                    .then(res => {
                        const { code, msg, data } = res;
                        this.lgspaymentDetails = data;
                    })
                    .catch(err => {
                        this.$toast(err);
                    });
            },
            toSydetailsRefund(investApplyno) {
                bridgeRedirect(`${location.origin}${location.pathname}#/sydetailsRefund?token=${this.token}&investApplyno=${investApplyno}`);
            },
            relatedFile(materialId) {
                /* console.log(`${location.origin}${location.pathname}#/financialGuide?token=${this.token}&materialId=${materialId}&type=0`); */
                bridgeRedirect(`${location.origin}${location.pathname}#/financialGuide?token=${this.token}&materialId=${materialId}&type=0`);
            },
            downFile() {
                let self = this;
                sensors.track("TMRelatedAgreements");
                let mask = this.$confirm({
                    title: "下载协议",
                    closeAble: false,
                    content: "<p style='text-align: center;'>您确定要下载该产品的电子协议吗？</p>",

                    ok() {
                        mask.close();
                        self.$request({
                            method: "post",
                            url: "/h5/sesame/getSignedUrl.json",
                            data: self.$qs.stringify({
                                appRequestId: self.lgspaymentDetails.appRequestId,
                                token: self.token
                            })
                        })
                            .then(res => {
                                const { data } = res;
                                downloadFile({
                                    url: data.msg,
                                    isAes: "0", // 0：不加密。1：加密，
                                    suffix: "pdf"
                                });
                            })
                            .catch(err => {
                                this.$toast(err);
                            });
                    }
                }).show();
            },
            cancelOrder(){
                let _self = this;
                let mask = this.$confirm({
                    title: "温馨提示",
                    closeAble: false,
                    content: "<p style='text-align: center;'>取消后您可再次申请，确定取消吗？</p>",
                    ok() {
                        mask.close();
                        _self
                            .$request({
                                method: "post",
                                url: `/h5/sesame/cancelTrade.json`,
                                data: _self.$qs.stringify({
                                    tradeId: _self.tradeId,
                                    token: _self.token
                                })
                            })
                            .then(res => {
                                mask.close();
                                callHandler("xhCancelOrderSuc");
                            })
                            .catch(err => {
                                mask.close();
                                _self.$toast(err);
                            });
                    }
                }).show();
            }
        }
    };
</script>
<style lang="less">
    @import "../css/orderDetails.less";

    .sy {
        margin-top: 8px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        padding-bottom: 12px !important;

        li:first-child {
            padding-top: 12px !important;
        }
    }

    .order-adviser {
        margin-bottom: 70px;
    }
</style>
